import { Entity, Version } from "../../types";
import { Car } from "../cars/types";
import { DueDateType } from "../dueDateTypes/types";
import { User } from "../users/types";

export type DueDate = Entity & {
  car: Car;
  type: DueDateType;
  date: string;
  isSettled: boolean;
  visibleToUser: User | null;
  hasAttachments: boolean;
};

export type DueDateNoCarDependency = Omit<DueDate, "car"> & {
  car: {
    id: string;
    vehicleIdentificationNumber: string;
    currentPlateNumber?: string;
    lastPlateNumber?: string;
    currentAssignment?: {
      carDriver?: {
        id: string;
        driver: {
          id: string;
          fullName: string;
        };
      };
      otherCarAssignment?: {
        id: string;
        type: {
          id: string;
          name: string;
        };
      };
    };
  };
};

export type DueDateVersion = Version & {
  car?: Car;
  type?: DueDateType;
  date: string;
  isSettled: boolean;
  visibleToUser?: User;
};

export type UpsertDueDate = {
  carId: string;
  typeId: string;
  date: string;
  isSettled: boolean;
  currentVersionNumber?: number;
  visibleToUserId?: string;
};

export type RenewDueDates = {
  date: string;
  dueDateIds: string[];
};

export type SettleDueDates = {
  dueDateIds: string[];
};

export type RenewMyCarDueDate = {
  date?: string;
  files?: File[];
};

export type DueDateStats = {
  totalOpen: number;
  totalExpiringSoon: number;
  totalExpired: number;
};

export const isItemExpiringSoon = (date: string, isSettled: boolean): boolean => {
  const d = new Date(date);
  const today = new Date();
  const limit = new Date();
  limit.setDate(today.getDate() + 21);
  if (d < limit && d >= today && !isSettled) {
    return true;
  }

  return false;
};

export const isItemExpired = (date: string, isSettled: boolean): boolean => {
  const d = new Date(date);
  const today = new Date();
  if (d <= today && !isSettled) {
    return true;
  }
  return false;
};
